export default __webpack_public_path__ + "navigation-overview-setup-ib-segue-960-ccb7e178cb2a77698c7ed74877cac0ad.png";